import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesPaymentImportRow} from "../../../../shared/interface/receivables-payment-import-row";
import {ReceivablesPaymentImportRowService} from "../../../../shared/services/receivables-payment-import-row.service";

@Component({
  selector: 'app-receivables-payment-import-row-details',
  templateUrl: './receivables-payment-import-row-details.component.html',
  styleUrls: ['./receivables-payment-import-row-details.component.scss']
})
export class ReceivablesPaymentImportRowDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  receivablesPaymentImportRowwId: string;
  receivablesPaymentImportRowObject?: ReceivablesPaymentImportRow;
  receivablesPaymentImportRow: ReplaySubject<ReceivablesPaymentImportRow> = new ReplaySubject<ReceivablesPaymentImportRow>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private receivablesPaymentImportsRowService: ReceivablesPaymentImportRowService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.receivablesPaymentImportRowwId = params.id;
        this.loadReceivablesPaymentImportsRow();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadReceivablesPaymentImportsRow(): void {
    this.receivablesPaymentImportsRowService.get(this.receivablesPaymentImportRowwId).subscribe((receivablesPaymentImportRow: ReceivablesPaymentImportRow) => {
      this.receivablesPaymentImportRow.next(receivablesPaymentImportRow);
      this.receivablesPaymentImportRowObject = receivablesPaymentImportRow;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
